import {
  Button,
  HSpacer,
  Text,
} from '@/components/DesignSystem';
import Add from '@mui/icons-material/Add';
import { BottomNavigation, BottomNavigationAction, Container, Stack } from '@mui/material';
import { CreateNotificationModal } from './modals/CreateNotificationModal';
import { NotificationBuilderTable } from
  '@/pages/Admin/NotificationBuilder/components/NotificationBuilderTable';
import { NotificationDraftTable } from
  '@/pages/Admin/NotificationBuilder/components/NotificationDraftTable';
import { useState } from "react";
import { useTranslation } from 'react-i18next';

export const NotificationBuilder = () => {
  const { t } = useTranslation();
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [tabIndex, setTabIndex] = useState("0");
  const [draftTable, setDraftTable] = useState(false);

  const Header = (
    <Stack direction="row" justifyContent="space-between">
      <Text category="display-small">
        {t($ => $.notificationBuilder.title)}
      </Text>
      <Stack alignItems="center" direction="row">
        <HSpacer size="7" />
        <Button
          onClick={() => setShowCreateModal(true)}
          size="giant"
          startIcon={<Add />}
          sx={{ fontSize: "16px", borderRadius: "16px" }}
          testID="create-notification-button"
        >
          {t($ => $.notificationBuilder.actions.create)}
        </Button>
      </Stack>
    </Stack>
  );

  return (
    <Container maxWidth="lg">
      {Header}
      <Stack direction="row" spacing={6} sx={{ marginBottom: '16px', marginTop: '16px' }}>
        <BottomNavigation
          showLabels
          sx={{
            borderBottom: '2px solid #e0e0e0',
            justifyContent: 'left',
            fontSize: '14px',
            backgroundColor: 'unset',
            height: '48px',
            width: '100%',
          }}
          value={tabIndex}
        >
          <BottomNavigationAction
            label={t($ => $.notificationBuilder.tabs.customNotifications)}
            onClick={() => {
              setDraftTable(false);
              setTabIndex("0");
            }}
            sx={{
              minWidth: '300px',
              height: '30px',
              '&.Mui-selected': {
                borderBottom: '2px solid #67790F',
                height: '48px',
                borderRadius: 0,
              },
              '.MuiBottomNavigationAction-label': {
                minWidth: '400px',
                textTransform: 'none',
                fontSize: '14px',
                marginTop: 0,
                height: '30px',
              },
            }}
            value="0"
          />
          <BottomNavigationAction
            label={t($ => $.notificationBuilder.tabs.draft)}
            onClick={() => {
              setTabIndex("1");
              setDraftTable(true);
            }}
            sx={{
              minWidth: '300px',
              height: '30px',
              '&.Mui-selected': {
                borderBottom: '2px solid #67790F',
                height: '48px',
                borderRadius: 0,
              },
              '.MuiBottomNavigationAction-label': {
                minWidth: '400px',
                textTransform: 'none',
                fontSize: '14px',
                marginTop: 0,
                height: '30px',
              },
            }}
            value="1"
          />
        </BottomNavigation>
      </Stack>
      {draftTable ? (
        <NotificationDraftTable />
      ) : (
        <NotificationBuilderTable />
      )}
      {showCreateModal && (
        <CreateNotificationModal
          onClose={() => setShowCreateModal(false)}
          onDraftSaved={() => {
            setTabIndex("1");
            setDraftTable(true);
          }}
          open={showCreateModal}
          testID="create-notification-modal"
        />
      )}
    </Container>
  );
};
